// Concordium grant pitch deck - focused on blockchain integration
import {
  SlidePresenter,
  TechSlide,
  AuditSlide,
} from "../../sections/BrandSlides";

const slides = [AuditSlide, TechSlide];

export default function ConcordiumDeck() {
  return <SlidePresenter slides={slides} />;
}
